import { render, staticRenderFns } from "./sessions.vue?vue&type=template&id=25ea6c0c&"
import script from "./sessions.vue?vue&type=script&lang=ts&"
export * from "./sessions.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports